<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.ti-radar-chart
    +e.SVG.svg(
      :width="width",
      :height="height",
      viewBox="0 0 600 600"
    )
</template>

<script>
/* eslint-disable */
import d3 from './../../tools/d3/d3';

export default {
  name: 'ti-radar-chart',
  props: {
    // Набір даних, що передається для відображення
    dataSet: {
      type: Array,
      default: () => [],
    },
    // Коротка чи велика версія
    short: {
      type: Boolean,
      default: false,
    },
    // Конфіг
    cfg: {
      type: Object,
      default: () => ({
        // Width of the circle
        w: 600,
        // Height of the circle
        h: 600,
        // The margins of the SVG
        margin: {
          top: 100,
          right: 100,
          bottom: 100,
          left: 100,
        },
        // How many levels or inner circles should there be drawn
        levels: 5,
        // What is the value that the biggest circle will represent
        maxValue: 1,
        // How much farther than the radius of the outer circle should the labels be placed
        labelFactor: 1.25,
        // The number of pixels after which a label needs to be given a new line
        wrapWidth: 60,
        // The opacity of the area of the blob
        opacityArea: 0.35,
        // The size of the colored circles of each blog
        dotRadius: 4,
        // The opacity of the circles of each blob
        opacityCircles: 0.1,
        // The width of the stroke around each blob
        strokeWidth: 2,
        // If true the area and stroke will follow a round path (cardinal-closed)
        roundStrokes: true,
        // Color function
        color: d3.scaleOrdinal(d3.schemeCategory10),
      }),

    },
  },
  data() {
    return {
      width: 0,
      height: 0,
      svg: null,
      g: null,
      id: null,
      maxValue: null,
      allAxis: null,
      total: null,
      radius: null,
      angleSlice: null,
      Format: null,
      rScale: null,
    };
  },
  computed: {
    padded() {
      const width = this.width;
      const height = this.height;
      return { width, height };
    },
    radiusNumber() {
      return parseInt(this.radius, 10);
    },
  },
  mounted() {
    this.id = this._uid;
    window.addEventListener('resize', this.onResize);
    this.onResize();
    // this.draw();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    width: function widthChanged() {
      this.initialize();
      // this.update();
    },
    dataSet: function dataUpdated() {
      if (this.dataSet.length === 2) {
        this.initialize();
        // this.update();
        // d3.select(this.$el.querySelector('svg')).selectAll('*').remove();
        // this.initialize();
        // this.onResize();
      }
    }
  },
  methods: {
    onResize() {
      this.width = this.$el.offsetWidth;
      this.height = this.$el.offsetHeight;
    },
    initialize() {
      const self = this;
      let cfg = this.cfg;

      //Put all of the options into a variable called cfg
      // if('undefined' !== typeof options){
      //   for(let i in options){
      //   if('undefined' !== typeof options[i]){ cfg[i] = options[i]; }
      //   }//for i
      // }//if

      //If the supplied maxValue is smaller than the actual one, replace by the max in the data
      this.maxValue = Math.max(cfg.maxValue, d3.max(self.dataSet, function(i){return d3.max(i.map(function(o){return o.value;}))}));

      this.allAxis = (this.dataSet[0].map(function(i, j){return i.axis}));	//Names of each axis
      this.total = this.allAxis.length;					//The number of different axes
      this.radius = Math.min(cfg.w/2, cfg.h/2); 	//Radius of the outermost circle

       // Форматирование процентов без знаков после запятой
      this.Format = d3.format('.0%');
      this.angleSlice = Math.PI * 2 / self.total;		//The width in radians of each 'slice'

      //Scale for the radius
      this.rScale = d3.scaleLinear()
        .range([0, self.radius])
        .domain([0, self.maxValue]);

      /////////////////////////////////////////////////////////
      //////////// Create the container SVG and g /////////////
      /////////////////////////////////////////////////////////

      //Remove whatever chart with the same id/class was present before
      // d3.select(id).select('svg').remove();
      if (this.svg) {
        this.svg.selectAll('*').remove();
      }
      //Initiate the radar chart SVG
      this.svg = d3.select(this.$el.querySelector('svg'))
        .attr('width', this.padded.width)
        .attr('height', this.padded.height);


      // Заокментированный код так как селектим по другому
      // let svg = d3.select(id).append('svg')
      //     .attr('width',  cfg.w + cfg.margin.left + cfg.margin.right)
      //     .attr('height', cfg.h + cfg.margin.top + cfg.margin.bottom)
      //     .attr('class', 'radar'+id);

      //Append a g element
      this.g = this.svg.append('g')
          .attr('transform', 'translate(' + (cfg.w/2 + cfg.margin.left) + ',' + (cfg.h/2 + cfg.margin.top) + ')')
          .classed('ti-radar-chart__group', true);

      this.drawBG();
      this.draw(this.cfg);
    },
    drawBG() {
      const self = this;
      const cfg = this.cfg;

      /////////////////////////////////////////////////////////
      ////////// Glow filter for some extra pizzazz ///////////
      /////////////////////////////////////////////////////////

      //Filter for the outside glow
      let filter = this.g.append('defs').append('filter').attr('id','glow'),
        feGaussianBlur = filter.append('feGaussianBlur').attr('stdDeviation','2.5').attr('result','coloredBlur'),
        feMerge = filter.append('feMerge'),
        feMergeNode_1 = feMerge.append('feMergeNode').attr('in','coloredBlur'),
        feMergeNode_2 = feMerge.append('feMergeNode').attr('in','SourceGraphic');

      /////////////////////////////////////////////////////////
      /////////////// Draw the Circular grid //////////////////
      /////////////////////////////////////////////////////////

      //Wrapper for the grid & axes
      let axisGrid = this.g.append('g').attr('class', 'axisWrapper');

      //Draw the background circles
      axisGrid.selectAll('.levels')
        .data(d3.range(1,(cfg.levels+1)).reverse())
        .enter()
        .append('circle')
        .attr('class', 'gridCircle')
        .attr('r', function(d, i){return self.radius/cfg.levels*d;})
        .style('fill', '#CDCDCD')
        .style('stroke', '#CDCDCD')
        .style('fill-opacity', cfg.opacityCircles)
        .style('filter' , 'url(#glow)');

      // Отображение процентов на оси координат
      axisGrid.selectAll('.axisLabel')
        .data(d3.range(1,(cfg.levels + 1)).reverse())
        .enter().append('text')
        .attr('class', 'axisLabel')
        .attr('x', 4)
        .attr('y', function(d) {return -d*self.radius / cfg.levels; })
        .attr('dy', '0.4em')
        .style('font-size', '10px')
        .attr('fill', '#737373')
        .text(function(d,i) {
          return self.Format((d / self.maxValue) * cfg.levels * 4);
        });

      /////////////////////////////////////////////////////////
      //////////////////// Draw the axes //////////////////////
      /////////////////////////////////////////////////////////

      //Create the straight lines radiating outward from the center
      let axis = axisGrid.selectAll('.axis')
        .data(self.allAxis)
        .enter()
        .append('g')
        .attr('class', 'axis');
      //Append the lines
      axis.append('line')
        .attr('x1', 0)
        .attr('y1', 0)
        .attr('x2', function(d, i){ return self.rScale(self.maxValue*1.1) * Math.cos(self.angleSlice*i - Math.PI/2); })
        .attr('y2', function(d, i){ return self.rScale(self.maxValue*1.1) * Math.sin(self.angleSlice*i - Math.PI/2); })
        .attr('class', 'line')
        .style('stroke', 'white')
        .style('stroke-width', '2px');

      //Append the labels at each axis
      if (!this.short) {
        axis.append('text')
          .attr('class', 'legend')
          .style('font-size', '11px')
          .attr('text-anchor', 'middle')
          .attr('dy', '0.35em')
          .attr('x', function(d, i){ return self.rScale(self.maxValue * cfg.labelFactor) * Math.cos(self.angleSlice*i - Math.PI/2); })
          .attr('y', function(d, i){ return self.rScale(self.maxValue * cfg.labelFactor) * Math.sin(self.angleSlice*i - Math.PI/2); })
          .text(function(d){return d})
          .call(this.wrap, cfg.wrapWidth);
      }
    },
    update() {
      let cfg = this.cfg;
      const self = this;
      /////////////////////////////////////////////////////////
      ///////////// Draw the radar chart blobs ////////////////
      /////////////////////////////////////////////////////////

      let blobWrapper = this.g.selectAll('.radarWrapper').remove();
      let blobCircleWrapper = this.g.selectAll('.radarCircleWrapper').remove();
      this.draw(this.cfg);
    },
    draw(options) {
      let cfg = this.cfg;
      const self = this;

      /////////////////////////////////////////////////////////
      ///////////// Draw the radar chart blobs ////////////////
      /////////////////////////////////////////////////////////

      //The radial line function
      let radarLine = d3.radialLine()
        .curve(d3.curveLinearClosed)
        .radius(function(d) { return self.rScale(d.value); })
        .angle(function(d,i) {	return i*self.angleSlice; });

      if(cfg.roundStrokes) {
        radarLine.curve(d3.curveCardinalClosed);
      }

      //Create a wrapper for the blobs
      let blobWrapper = this.g.selectAll('.radarWrapper')
        .data(self.dataSet)
        .enter().append('g')
        .attr('class', 'radarWrapper');

      //Append the backgrounds
      blobWrapper
        .append('path')
        .attr('class', 'radarArea')
        .attr('d', function(d,i) { return radarLine(d); })
        .style('fill', function(d,i) { return cfg.color(i); })
        .style('fill-opacity', cfg.opacityArea)
        .on('mouseover', function (d,i){
          //Dim all blobs
          d3.selectAll('.radarArea')
            .transition().duration(200)
            .style('fill-opacity', 0.1);
          //Bring back the hovered over blob
          d3.select(this)
            .transition().duration(200)
            .style('fill-opacity', 0.7);
        })
        .on('mouseout', function(){
          //Bring back all blobs
          d3.selectAll('.radarArea')
            .transition().duration(200)
            .style('fill-opacity', cfg.opacityArea);
        });

      //Create the outlines
      blobWrapper.append('path')
        .attr('class', 'radarStroke')
        .attr('d', function(d,i) { return radarLine(d); })
        .style('stroke-width', cfg.strokeWidth + 'px')
        .style('stroke', function(d,i) { return cfg.color(i); })
        .style('fill', 'none')
        .style('filter' , 'url(#glow)');

      //Append the circles
      blobWrapper.selectAll('.radarCircle')
        .data(function(d,i) { return d; })
        .enter().append('circle')
        .attr('class', 'radarCircle')
        .attr('r', cfg.dotRadius)
        .attr('cx', function(d,i){ return self.rScale(d.value) * Math.cos(self.angleSlice*i - Math.PI/2); })
        .attr('cy', function(d,i){ return self.rScale(d.value) * Math.sin(self.angleSlice*i - Math.PI/2); })
        .style('fill', function(d,i,j) { return cfg.color(j); })
        .style('fill-opacity', 0.8);

      /////////////////////////////////////////////////////////
      //////// Append invisible circles for tooltip ///////////
      /////////////////////////////////////////////////////////

      //Wrapper for the invisible circles on top
      let blobCircleWrapper = this.g.selectAll('.radarCircleWrapper')
        .data(this.dataSet)
        .enter().append('g')
        .attr('class', 'radarCircleWrapper');

      //Append a set of invisible circles on top for the mouseover pop-up
      blobCircleWrapper.selectAll('.radarInvisibleCircle')
        .data(function(d,i) { return d; })
        .enter().append('circle')
        .attr('class', 'radarInvisibleCircle')
        .attr('r', cfg.dotRadius*1.5)
        .attr('cx', function(d,i){ return self.rScale(d.value) * Math.cos(self.angleSlice*i - Math.PI/2); })
        .attr('cy', function(d,i){ return self.rScale(d.value) * Math.sin(self.angleSlice*i - Math.PI/2); })
        .style('fill', 'none')
        .style('pointer-events', 'all')
        .on('mouseover', function(d,i) {

          let newX =  parseFloat(d3.select(this).attr('cx')) - 10;
          let newY =  parseFloat(d3.select(this).attr('cy')) - 10;

          tooltip
            .attr('x', newX)
            .attr('y', newY)
            .text(self.Format(d.value))
            .transition().duration(200)
            .style('opacity', 1);
        })
        .on('mouseout', function(){
          tooltip.transition().duration(200)
            .style('opacity', 0);
        });

      //Set up the small tooltip for when you hover over a circle
      let tooltip = this.g.append('text')
        .attr('class', 'tooltip')
        .style('opacity', 0);


    },
    /////////////////////////////////////////////////////////
    /////////////////// Helper Function /////////////////////
    /////////////////////////////////////////////////////////

    //Taken from http://bl.ocks.org/mbostock/7555321
    //Wraps SVG text
    wrap(text, width) {
      text.each(function() {
        let text = d3.select(this);
        let words = text.text().split(/\s+/).reverse();
        let word;
        let line = [];
        let lineNumber = 0;
        let lineHeight = 1.4; // ems
        let y = text.attr('y');
        let x = text.attr('x');
        let dy = parseFloat(text.attr('dy'));
        let tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');

        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
          }
        }
      });
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/styles';

.ti-radar-chart {
  position: relative;
  width: 600px;
  height: 600px;

  &__svg {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TIRadarChart/TIRadarChart.vue